import React, { useEffect, useMemo, useState } from 'react';
import { SingleBreadcrumbItem } from 'framework/ui/BreadCrumbs';
import VacancyGroupsBreadcrumbs from './VacancyGroupsBreadcrumbs';
import { useVacancyGroupId, useVacancyGroupUrl } from 'domain/recruiting/newVacancy/routing';
import { useShowContext } from 'framework/show';
import { useFormContext } from 'framework/form';

const SingleVacancyBreadcrumbs = ({
  children = null,
  onClickCallback,
  entity: entityOverride,
}: {
  children?: React.ReactNode | React.ReactNode[] | null;
  onClickCallback: () => void;
  entity?: string | null;
}) => {
  const { data } = useShowContext();
  const { data: formData } = useFormContext();
  const { getSingleEntityUrl } = useVacancyGroupUrl();
  const id = useVacancyGroupId();

  const [initialEntityName, setInitialEntityName] = useState<string | null>(null);

  useEffect(() => {
    if (!initialEntityName && formData?.name) {
      setInitialEntityName(formData.name);
    }
  }, [formData?.name, initialEntityName]);

  const entity = useMemo(() => {
    return entityOverride || initialEntityName || data.getValueBySource('specialization');
  }, [data, entityOverride, initialEntityName]);

  return (
    <VacancyGroupsBreadcrumbs>
      <SingleBreadcrumbItem entity={entity} link={getSingleEntityUrl(id)} onClickCallback={onClickCallback} />
      {children}
    </VacancyGroupsBreadcrumbs>
  );
};

export default SingleVacancyBreadcrumbs;
